import BuildingType from '@/roc/building/BuildingType';
import Effects from '@/roc/effects/Effects';
import ProductionOutputType from '@/roc/effects/Production/ProductionOutputType';
import ProductionCurrency from '@/roc/effects/Production/ProductionCurrency';
import ProductionQueue from '@/roc/effects/Production/ProductionQueue';
import ProductionWorkforce from '@/roc/effects/Production/ProductionWorkforce';
import ProductionCost from '@/roc/effects/Production/ProductionCost';
import ProductionDuration from '@/roc/effects/Production/ProductionDuration';
import ProductionOutput from '@/roc/effects/Production/ProductionOutput';

const WinterPavilion = {
  id: '136',
  name: 'Winter Pavillion',
  width: 3,
  height: 2,
  type: BuildingType.COLLECTABLE,
  era: 'stoneAge',
  icon: 'Winter_Pavilion',
  minLevel: 1,
  maxLevel: 40,
  url: 'https://riseofcultures.wiki.gg/wiki/Buildings/Winter_Pavilion',
  flags: 0,
  counts: null,
  effects: Effects.create([
    new ProductionQueue(
      ProductionWorkforce.asFlat(5),
      [
        ProductionCost.asFlat(5).withCurrency(ProductionCurrency.RESEARCH_POINTS),
        ProductionCost.asFlat(20).withCurrency(ProductionCurrency.GEARS),
      ],
      ProductionDuration.asCallbackWithLevel(
        (level) => {
          return 17 * 60 * 60 - ((level - 1) * 15 * 60);
        }
      ),
      ProductionOutput.asFlat(1).withOutput(ProductionOutputType.WONDER_HELP_REQUEST),
    ),
  ]),
};

export default WinterPavilion;
